
import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';
import './About.css';

const About = () => {
  const [ref, isVisible] = useIntersectionObserver();

  const problems = [
    {
      title: "Strategy Gaps",
      desc: "Vision that is lost in translation and doesn't reach the execution layer."
    },
    {
      title: "Intent Dilution",
      desc: "Leadership's core intent getting diluted as it passes through organization layers."
    },
    {
      title: "System Lag",
      desc: "Operating processes and systems that fail to scale with organizational growth."
    },
    {
      title: "Outcome Drift",
      desc: "Teams working with high effort, yet results continuously drifting from targets."
    }
  ];

  return (
    <section className="about-section-wrapper" ref={ref} id="problem-landscape">
      <div className="container">
        <motion.div
          className="about-header"
          initial="initial"
          animate={isVisible ? "animate" : "initial"}
          variants={fadeInUp}
        >
          <h3 className="about-main-title">The Problem Landscape</h3>
          <p className="about-subtitle-text">
            Growth creates massive opportunity, but also deep complexity.
            As organizations scale, hidden gaps begin to appear.
          </p>
        </motion.div>

        <motion.div
          className="problem-cards-grid"
          variants={staggerContainer}
          initial="initial"
          animate={isVisible ? "animate" : "initial"}
        >
          {problems.map((problem, index) => (
            <motion.div key={index} className="problem-landscape-card" variants={staggerItem}>
              <div className="problem-card-icon-dot"></div>
              <h4 className="problem-card-title">{problem.title}</h4>
              <p className="problem-card-desc">{problem.desc}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="about-closure-statement"
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <p>
            Most challenges are not capability gaps they are
            <strong> clarity and system gaps</strong>.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
